import { IArticleContent } from 'enhancers/withArticleData';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';

type Props = IArticleContent & WithLanguageProps;

export const ArticleSection: React.SFC<Props> = props => {
  const getContent = () => {
    switch (props.Type) {
      case 'Image Left':
        return (
          <React.Fragment>
            <ImageContainer>
              <img src={props.Image && props.Image.src} />
            </ImageContainer>
            <Content source={props.getText(props.Content)} />
          </React.Fragment>
        );
      case 'Image Right':
        return (
          <React.Fragment>
            <Content source={props.getText(props.Content)} />
            <ImageContainer>
              <img src={props.Image && props.Image.src} />
            </ImageContainer>
          </React.Fragment>
        );
      case 'Image Only':
        return (
          <ImageContainer>
            <img src={props.Image && props.Image.src} />
          </ImageContainer>
        );
      case 'Text Only':
      default: {
        return <Content source={props.getText(props.Content)} />;
      }
    }
  };
  return <Container>{getContent()}</Container>;
};

const Container = styled.div`
  display: flex;
  padding: 10px 0;
  & > * {
    flex: 1 1 50%;
    padding: 5px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    & > * {
      flex: 1 1 auto;
    }
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
  }
`;

const Content = styled(Markdown)`
  p {
    font-size: 20px;
  }
  @media (max-width: 900px) {
    p {
      font-size: 16px;
    }
  }
`;

export default withLanguageState(ArticleSection);



// WEBPACK FOOTER //
// ./src/components/ArticleSection/ArticleSection.tsx